import { useEffect, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";

export function AnimatedSceneBackground({ color, transitionSpeed = 6 }) {
  const { scene, invalidate } = useThree();
  const targetColor = useRef(new THREE.Color(color));

  useEffect(() => {
    targetColor.current.set(color);
    if (!(scene.background instanceof THREE.Color)) {
      scene.background = new THREE.Color(color);
    }
  }, [color, scene]);

  useFrame((_, delta) => {
    if (!(scene.background instanceof THREE.Color)) {
      scene.background = new THREE.Color(targetColor.current);
      return;
    }
    const alpha = 1 - Math.exp(-transitionSpeed * delta);
    const before = scene.background.clone();
    scene.background.lerp(targetColor.current, alpha);
    const moved =
      Math.abs(scene.background.r - before.r) +
      Math.abs(scene.background.g - before.g) +
      Math.abs(scene.background.b - before.b);
    if (moved > 0.0002) invalidate();
  });

  return null;
}
